import { KNOWN_PERIODS } from "./periodConstants";
import { getPeriodToggleLabelKey } from "./periodLabels";

/**
 * Build toggle options from allowed periods.
 *
 * @param {object} params
 * @param {number[]} params.allowedPeriods
 * @param {(key: string) => string} params.translate
 * @param {Record<number, string>} [params.labelKeysByPeriod] - override toggle label keys (e.g. promo)
 * @param {object} [params.yearlyTooltip]
 * @param {string|null} [params.yearlyTooltip.tooltipTop]
 * @param {string|null} [params.yearlyTooltip.tooltipBottom]
 * @param {string|null} [params.yearlyTooltip.tooltipRight]
 * @returns {Array<{ value: number, label: string, tooltipTop?: string, tooltipBottom?: string, tooltipRight?: string }>}
 */
const getPeriodToggleOptions = ({
  allowedPeriods,
  translate,
  labelKeysByPeriod,
  yearlyTooltip
}) => {
  if (!Array.isArray(allowedPeriods) || typeof translate !== "function") {
    return [];
  }

  return allowedPeriods
    .map(period => {
      const labelKey =
        labelKeysByPeriod?.[period] ?? getPeriodToggleLabelKey(period);
      if (!labelKey) {
        return null;
      }

      const option = {
        value: period,
        label: translate(labelKey)
      };

      if (period === KNOWN_PERIODS.YEARLY && yearlyTooltip) {
        if (yearlyTooltip.tooltipTop) {
          option.tooltipTop = yearlyTooltip.tooltipTop;
        }
        if (yearlyTooltip.tooltipBottom) {
          option.tooltipBottom = yearlyTooltip.tooltipBottom;
        }
        if (yearlyTooltip.tooltipRight) {
          option.tooltipRight = yearlyTooltip.tooltipRight;
        }
      }

      return option;
    })
    .filter(Boolean);
};

export default getPeriodToggleOptions;
